import {
    MapOptions
} from "esdm-map/dist";
import { WesternIslesBaseLayerTypes } from "./WesternIslesBaseMapping_27700";

export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {       

        let opt = new MapOptions();       
        opt.bingApiKey = $(`#${mapElementId}`).data("bing-api-key");
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [WesternIslesBaseLayerTypes.WesternIslesAerial, WesternIslesBaseLayerTypes.WesternIslesOS];        
        opt.defaultBaseMap = WesternIslesBaseLayerTypes.WesternIslesOS;
        opt.enableBoundsTracking = true;
        opt.zoomToNearestBounds = false;
        opt.maxZoomToBounds = 12;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 4;
        opt.minZoom = 4;
        opt.maxZoom = 15;      

        opt.extent = [3000, 700000, 210137, 1100000];
        opt.mapCentre = [
            105000, 887500
        ];    

        opt.displayProjection = "EPSG:27700";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;                
        return opt;
    }

}
